import React, {useState, useEffect} from 'react';
import * as S from './RescheduleInfoBlock.styles';

import DateChangeBlock from './DateChangeBlock/DateChangeBlock';
import EditGuestBlock from './EditGuestBlock/EditGuest';

const RescheduleInfoBlock = ({dateInfo, roomInfo, fcdt, updateParams, checkAvailability, isCheckAvailabilityDisabled}) => {
  const [disabled, setDisable] = useState(isCheckAvailabilityDisabled);
  useEffect(() => {
    if (disabled !== isCheckAvailabilityDisabled) {
      setDisable(isCheckAvailabilityDisabled);
    }
  }, [isCheckAvailabilityDisabled])
  return(
    <S.RescheduleInfoMainWrap>
      <S.InfoBlockHeadWrap>
        <S.InfoBlockHeadText>Select New Dates</S.InfoBlockHeadText>
        <S.InfoBlockSubText>Your booking has free cancellation till {fcdt}. Just pay the difference in tariff to change dates.</S.InfoBlockSubText>
      </S.InfoBlockHeadWrap>
      <DateChangeBlock dateInfo={dateInfo} updateParams={updateParams} />
      <EditGuestBlock roomInfo={roomInfo} updateParams={updateParams} />
      <S.RefundBtnWrap  disabled={disabled} onClick={checkAvailability}>
        <S.RefundBtn>CHECK AVAILABILITY</S.RefundBtn>
      </S.RefundBtnWrap>
    </S.RescheduleInfoMainWrap>
  );
};

export default RescheduleInfoBlock;